import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./guards/authGuardService";

const routes: Routes = [
  {
    path: "main",
    loadChildren: () =>
      import("./pages/tabs/tabs.module").then((m) => m.TabsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "menu",
    loadChildren: () =>
      import("./pages/menu/menu.module").then((m) => m.MenuModule),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "forget-password",
    loadChildren: () =>
      import("./pages/forget-password/forget-password.module").then(
        (m) => m.ForgetPasswordModule
      ),
  },
  {
    path: "create-password",
    loadChildren: () =>
      import("./pages/create-password/create-password.module").then(
        (m) => m.CreatePasswordModule
      ),
  },
  {
    path: "signup",
    loadChildren: () =>
      import("./pages/signup/signup.module").then((m) => m.SignUpModule),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.module").then(
        (m) => m.RegisterPageModule
      ),
  },
  {
    path: "register-otp",
    loadChildren: () =>
      import("./pages/register-otp/register-otp.module").then(
        (m) => m.RegisterOtpPageModule
      ),
  },
  {
    path: "register-createPass",
    loadChildren: () =>
      import(
        "./pages/register-create-password/register-create-password.module"
      ).then((m) => m.RegisterCreatePassPageModule),
  },
  {
    path: "select-interests",
    loadChildren: () =>
      import("./pages/select-interests/select-interests.module").then(
        (m) => m.SelectInterestsModule
      ),
  },

  {
    path: "live-campaign",
    loadChildren: () =>
      import("./pages/liveCampaigns/liveCampaigns.module").then(
        (m) => m.liveCampaignsModule
      ),
  },

  {
    path: "category-listing",
    loadChildren: () =>
      import("./pages/category-listing/category-listing.module").then(
        (m) => m.CategoryListingPageModule
      ),
  },
  {
    path: "coupons",
    loadChildren: () =>
      import("./pages/coupons/coupons.module").then((m) => m.couponsModule),
  },

  {
  path: "coupon-interest",
  loadChildren: () =>
    import("./pages/coupon-interest/coupon-intrest.module")
      .then((m) => m.CouponInterestPageModule),
},


  {
  path: "my-wishlist",
  loadChildren: () =>
    import("./pages/my-wishlist/my-wishlist.module")
      .then((m) => m.MyWishlistPageModule),
},

 
 

 
  {
    path: "top-up",
    loadChildren: () =>
      import("./pages/top-up/top-up.module").then((m) => m.TopUpModule),
  },
  {
    path: "pay-now",
    loadChildren: () =>
      import("./pages/pay-now/pay-now.module").then((m) => m.payNowModule),
  },
  {
    path: "termsAndConditions",
    loadChildren: () =>
      import("./pages/terms/terms.module").then((m) => m.TermsModule),
  },
  {
    path: "my-campaigns",
    loadChildren: () =>
      import("./pages/my-campaigns/my-campaigns.module").then((m) => m.MyCampaignsPageModule),
  },
  {
    path: "",
    redirectTo: "main",
    pathMatch: "full",
  },
  {
    path: "my-account",
    loadChildren: () =>
      import("./pages/tabs/main-page/my-account/my-account.module").then(
        (m) => m.MyAccountPageModule
      ),
  },



  {
    path: "live-campaign",
    loadChildren: () =>
      import("./pages/liveCampaigns/liveCampaigns.module").then(
        (m) => m.liveCampaignsModule
      ),
  },
  {
    path: "coupons",
    loadChildren: () =>
      import("./pages/coupons/coupons.module").then((m) => m.couponsModule),
  },
  {
    path: "top-up",
    loadChildren: () =>
      import("./pages/top-up/top-up.module").then((m) => m.TopUpModule),
  },
  {
    path: "pay-now",
    loadChildren: () =>
      import("./pages/pay-now/pay-now.module").then((m) => m.payNowModule),
  },

  {
    path: "termsAndConditions",
    loadChildren: () =>
      import("./pages/terms/terms.module").then((m) => m.TermsModule),
  },
  {
    path: "",
    redirectTo: "main", 
    pathMatch: "full",
  },
  {
    path: 'explore-deals-listing',
    loadChildren: () => import('./pages/explore-deals-listing/explore-deals-listing.module').then( m => m.ExploreDealsListingPageModule)
  },
  {
    path: 'customer-form',
    loadChildren: () => import('./pages/customer-form/customer-form.module').then( m => m.CustomerFormPageModule)
  },  {
    path: 'review',
    loadChildren: () => import('./pages/review/review.module').then( m => m.ReviewPageModule)
  },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
